<template>
    <div style="overflow-x: hidden" ref="contain">

        <div class="introduct_header" ref="introduct_header">
            <img src="../assets/8a840c090c221efd6ec7bf0634c9159f.jpg" alt="" style="width: 100vw;height: 100vh" >
            <ul class="animation">
                <li ><p>{{title}}</p></li>
                <li ><h2>Innovative Technologie zur Herstellung effizienter Magnetkerne</h2></li>
            </ul>
            <div ref="p1">
                <el-row :class="className">
                    <el-col v-for="(button,index) in buttons" :span="8" :key="index">
                        <a  :class="{ 'selected': button.selected }" @click="selectButton(button,index)">{{ button.label }}</a>
                    </el-col>






                </el-row>
            </div>
        </div>
        <!--        公司介绍-->
        <introduce v-show="buttons[0].selected " ref="introduce"></introduce>
        <!--        发展历程-->
        <development-introduce v-show="buttons[1].selected" ref="development"></development-introduce>
        <!--        荣誉资质-->
        <honor-qualification v-show="buttons[2].selected" ref="honor"></honor-qualification>


        <foot style="bottom: 0;;width: 100%"/>




    </div>
</template>

<script>
    import Introduce from "@/DE/About/Introduce";
    import DevelopmentIntroduce from "@/DE/About/DevelopmentIntroduce";
    import HonorQualification from "@/DE/About/HonorQualification";
    import Foot from "@/DE/components/Foot";
    export default {
        name: "About",
        components:{Introduce,DevelopmentIntroduce,HonorQualification,Foot},
        metaInfo: {
            title: 'Unternehmenseinführung: Nanjing Hengchuang Magnetoelectronics Co., Ltd ĎPowered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: 'Über uns',
                content: 'Hengchuang Magnetoelektronics Co., Ltd. ist ein professionelles Unternehmen, das sich mit Forschung, ' +
                    'Entwicklung, Produktion und Vertrieb von magnetischen Kernen der Hochfrequenz-Leistung beschäftigt. ' +
                    'Gegenwärtig gibt es zwei Fabriken im Qixia Bezirk, Nanjing Stadt, Jiangsu Provinz und Tianchang Stadt, ' +
                    'Anhui Provinz. Mit fortschrittlichen Produktionsanlagen und Managementmethoden produzieren wir verschiedene ' +
                    'hochwertige weichmagnetische Ferritkerne mit hoher Leistung und niedrigen Verlusten.'
            }]
        },
        data(){
            return{
                className:"el-row1",
                title:"Einführung",
                buttons:[
                    { id: 1, label: 'Einführung', selected: true },
                    { id: 2, label: 'Geschichte', selected: false },
                    { id: 3, label: 'Ehre', selected: false }
                ],
                isPC:true


            }
        },
        methods:{
            scrolling(){

                let s= window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop
                this.p1H=this.$refs.introduct_header.offsetHeight;

                //需要更改

                if (this.isPC){

                    if (s>=this.p1H-75-75){
                        this.className="el-row2";

                    }else {
                        this.className="el-row1";
                    }

                }else{

                    if (s>=this.p1H-60-50){
                        this.className="el-row2";

                    }else {
                        this.className="el-row1";
                    }
                }



            },
            selectButton(button,index) {

                if (this.isPC){
                    this.p1H=this.$refs.introduct_header.offsetHeight-75-75;
                }else{
                    this.p1H=this.$refs.introduct_header.offsetHeight-60-50;
                }
                //滚动条到指定位置
                window.scrollTo({
                    top: this.p1H,
                    behavior: 'smooth'
                });
                this.buttons = this.buttons.map(b => ({ ...b, selected: false }));
                this.buttons[index].selected=true
                this.title=this.buttons[index].label


            },
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },

        },
        mounted() {

            if (this._isMobile()) {
                this.isPC=false;
            }
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            window.addEventListener("scroll", this.scrolling);




        },


        beforeRouteLeave() {
            window.removeEventListener('scroll',  this.$refs.introduce.scrolling);
            window.removeEventListener("scroll", this.scrolling);

        },

    }

</script>

<style scoped="scoped">

    i:hover{
        cursor: pointer;
    }
    *{
        font-family: HarmonyOS_Sans_SC_Medium;
        overflow-y: hidden;
    }

    ul{
        list-style: none;
    }
    .introduct_header{


        position: relative;
        overflow: hidden;
    }
    .introduct_header ul{
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        z-index: 88;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;

    }

    .introduct_header ul p{
        font-size: 60px;
        color: #fff;


        line-height: 90px;

    }
    .introduct_header ul h2{
        font-family: myfont;

        font-size: 1.5rem;
        color: #000000;
        margin-top: 50px
    }
    .introduct_header .el-row1{
        position: absolute;
        top: calc( 100vh - 70px );
        font-family: myfont;
        color: white;
        z-index: 999;
        width: 100vw;
    }
    .introduct_header .el-row2{
        position: fixed;
        /*需要更改*/
        top: 75px;
        font-family: myfont;
        color: white;
        z-index: 999;
        width: 100vw;
    }
    .introduct_header .el-row .el-col{
        background: rgba(0, 0, 0, 0.15); /* 这将创建一个半透明的白色背景 */
        backdrop-filter: blur(3px); /* 这将应用一个模糊效果 */
        text-align: center;
        line-height: 75px;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
        font-size: 1.3rem;
        transition: all 0.8s ease
    }
    .introduct_header .el-row .el-col:last-child{
        border-right: none;
    }
    .introduct_header .el-row .el-col a{
        display: block;

    }
    .introduct_header .el-row .el-col:hover{
        color: #409eff;
        cursor: pointer;

    }

    /*按钮*/

    .selected {
        color: #409eff !important; /* 选中状态的颜色 */
    }

    .animation{
        opacity: 0;
        animation: moveUp 2s ease-in-out forwards;
    }
    @media screen and (max-width:768px) {
        .introduct_header .el-row2{
            position: fixed;
            /*需要更改*/
            top: 50px;
            font-family: myfont;
            color: white;
            z-index: 88;
            width: 100vw;
        }

        .introduct_header .el-row .el-col{
            background: rgba(0, 0, 0, 0.15); /* 这将创建一个半透明的白色背景 */
            backdrop-filter: blur(3px); /* 这将应用一个模糊效果 */
            text-align: center;
            line-height: 60px;
            border-right: 1px solid rgba(255, 255, 255, 0.2);
            font-size: 1em;
        }
        .introduct_header .el-row1{
            position: absolute;
            top: calc( 100vh - 60px );
            font-family: myfont;
            color: white;
            z-index: 88;
            width: 100vw;
        }
        .introduct_header{


            position: unset;
        }
        .introduct_header ul{
            width: 100vw;
            height: 100vh;
            display: block;
            z-index: 88;
            top: 30%;
            left:50%;
            margin-left: -50vw;


        }
        .introduct_header ul li{
            width: 100%;
            float: left;
        }

    }
</style>
